<template>
  <div id="CookiesModal" v-if="showCookies">
    <div v-if="showConsentiment && !openModal" class="dialog-overlay">
      <div class="dialog-modal">
        <div class="dialog-modal_content container p-3">
          <div class="px-2">
            <h5 class="text-primary"><b>Politicas de Cookies </b></h5>
            <h5 class="text-primary">
              <b>Esta página web usa cookies</b>
            </h5>
            <span>
              Para más información, acceder a nuestra
              <a
                href="https://www.joinnus.com/privacypolicies"
                target="_blank"
                rel="noopener noreferrer"
              >
                <b> Política de Privacidad </b>
              </a>
              y a nuestra
              <a
                href="https://www.joinnus.com/cookiespolicy"
                target="_blank"
                rel="noopener noreferrer"
              >
                <b> Política de Cookies </b>
              </a>
              .
              Puedes aceptar o rechazar todas las cookies, o configurarlas siguiendo
              las instrucciones indicadas en nuestra política de Cookies.
            </span>
          </div>
          <div class="dialog-modal_options">
            <div class="dm_button" @click="chooseAllCookies(true)">
              Aceptar
            </div>
            <div class="dm_button" @click="configCookies()">
              Configuración
            </div>
            <div class="dm_button" @click="chooseAllCookies(false)">
              Denegar
            </div>
          </div>
        </div>
      </div>
    </div>
    <CookieSelectionModal v-if="openModal" @isAceptAll="getChooseSelection" @isCustomizable="getCustomizableCookies"></CookieSelectionModal>
  </div>
</template>
<script>
  import CookieSelectionModal from "./CookieSelectionModal.vue"
  import { setCookie, removeCookie, cookieDetailList } from '../../utils/cookies'
  import api from "../../api"

  export default {
    name: 'cookies',
    components:{
      CookieSelectionModal,
    },
    props: {
      showCookies: {
        default: false
      }
    },
    data(){
      return{
        openModal: false,
        showConsentiment: true,
      }
    },
    computed: {
      user() {
        return this.$store.state.auth.user;
      },
    },
    methods:{
      configCookies(){
        this.openModal = true;
        this.showConsentiment = false;
      },
      chooseAllCookies(isAccept){
        const cookieList = cookieDetailList.map((c) => ({
          ...c,
          isChecked: c.title === 'Necesario' || isAccept,
        }));
        this.openModal = false;
        this.showConsentiment = false;
        this.setCookieFilter(cookieList)
      },
      async getChooseSelection(payload){
        const { cookie } = payload;
        this.openModal = false;
        this.showConsentiment = false;
        this.setCookieFilter(cookie);
      },
      getCustomizableCookies(cookie){
        this.openModal = false;
        this.showConsentiment = false;
        this.setCookieFilter(cookie);
      },
      async setCookieFilter(arr) {
        try {
          const { auth } = this.$store.state;
          removeCookie('sendCookies')
          if (auth && auth.user) {
            const payload = arr.map((fc) => ({
              type: fc.key,
              state: fc.isChecked ? 1 : 0,
              details: [],
            }));
            const value = JSON.stringify(arr);
            setCookie('consentCookies', value);
            await api.setCookies({ cookies: payload }, auth.token);
          }
        } catch (error) {
          if (error.response && error.response.status === 401) {
            // eslint-disable-next-line
            console.log('Error 401: No autorizado');
          } else {
            // eslint-disable-next-line
            console.error('Error al hacer la solicitud:', error.message);
          }
          // eslint-disable-next-line
          console.log('err', error);
        } finally {
          const value = JSON.stringify(arr);
          setCookie('consentCookies', value);
        }
      },
    },
  }
</script>
